<template>
  <div class="text-center">
      <h2>404</h2>
      <p class="mt-3">ページが存在しません。</p>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>